import React from 'react';
import { Button, Grid, Link } from '@material-ui/core';
import OpenInNew from '@material-ui/icons/OpenInNew';
import { connect } from 'react-redux';
import * as DevToolActions from 'app/actions/dev-tool/actions';
import DevFinicityBorrower from 'app/components/DevTool/DevFinicityBorrower';

class DevFinicity extends React.Component<any, any> {

  render() {

    return (
      <React.Fragment>
        <DevFinicityBorrower />
        <DevFinicityBorrower isCoBorrower />
        <Grid container style={{ padding: '10px 0' }}>
          <Button
            size    = 'small'
            color   = 'primary'
            variant = 'outlined'
            style   = {{ marginLeft: 15 }}
            onClick = { () => this.props.ajaxDeleteAllFinicityCustomers() }
          >
            Delete all Finicity Customers
          </Button>
        </Grid>
        <Grid container>
          <Link href='https://docs.finicity.com/test-the-apis/#test-the-apis-7'
            style={{ fontSize: 14, marginLeft: 15 }}
            target='_blank'
            rel='noreferrer'>
            Finicity Test MVS Examples <OpenInNew style={{ fontSize: 12 }}/>
          </Link>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = DevToolActions;
export default connect(null, mapDispatchToProps)(DevFinicity);
